<template>
  <div class="space-y-2 text-center">
    <img src="/assets/publish/give.png" class="mx-auto w-36" />
    <p>Have you claimed your username on NamiComi Social yet?</p>
    <NamiButton :href="`/${locale}/feed`" buttonType="primary" class="w-40">
      Go to the feed
    </NamiButton>
  </div>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp();
const locale = nuxtApp.$i18n.global.locale;
</script>
